import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { _get } from "../api/apiClient";
import { HttpStatusCode } from "axios";
import { CustomError } from "../api/CustomError";
import { CustomSuccess } from "../api/CustomSuccess";
import { setLoaderFalse, setLoaderTrue } from "./loaderSlice";

const initialState = {
  contacted: false,
  triggeredFrom: null,
  currentSubscription: null,
  expectedSubscription: null,
  isLoading: false,
};

export const contactUsThunk = createAsyncThunk(
  "contactUsThunk",
  async (
    {
      disableLoader = false,
      triggeredFrom,
      currentSubscription,
      expectedSubscription,
    },
    thunkAPI,
  ) => {
    try {
      if (!disableLoader) thunkAPI.dispatch(setLoaderTrue());
      const config = {
        successMessage: "Contacted succssfully.",
        errorMessage: "Something went wrong.",
      };
      const response = await _get(
        `/client/pro/request?feature=${triggeredFrom}&existingTier=${currentSubscription}&involvedTier=${expectedSubscription}`,
        {},
        {
          ...config,
          metadata: { ...config?.metadata, apiName: "contactUsThunk" },
        },
      );
      if (response?.statusCode !== HttpStatusCode.Ok) {
        throw CustomError(response, config);
      }
      const { data, error, message, status, statusCode, responseType } =
        CustomSuccess(response, {
          ...config,
          disableToast: true,
        });
      thunkAPI.dispatch(setLoaderFalse());
      return {
        data,
        error,
        message,
        status,
        statusCode,
        responseType,
        triggeredFrom,
        currentSubscription,
        expectedSubscription,
      };
    } catch (error) {
      thunkAPI.dispatch(setLoaderFalse());
      return thunkAPI.rejectWithValue(error?.error);
    }
  },
);

export const contactUsSlice = createSlice({
  name: "contactUs",
  initialState,
  reducers: {
    resetContactUs: (state, action) => {
      state.contacted = false;
      state.triggeredFrom = null;
      state.currentSubscription = null;
      state.expectedSubscription = null;
      state.isLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(contactUsThunk.fulfilled, (_state, _action) => {
        _state.contacted = true;
        _state.triggeredFrom = _action.payload.triggeredFrom;
        _state.currentSubscription = _action.payload.currentSubscription;
        _state.expectedSubscription = _action.payload.expectedSubscription;
        _state.isLoading = false;
      })
      .addCase(contactUsThunk.pending, (_state, _action) => {
        _state.contacted = false;
        _state.triggeredFrom = null;
        _state.currentSubscription = null;
        _state.expectedSubscription = null;
        _state.isLoading = true;
      })
      .addCase(contactUsThunk.rejected, (_state, _action) => {
        _state.contacted = false;
        _state.triggeredFrom = null;
        _state.currentSubscription = null;
        _state.expectedSubscription = null;
        _state.isLoading = false;
      });
  },
});

export const { resetContactUs } = contactUsSlice.actions;

export default contactUsSlice.reducer;
